import _ from 'lodash';
import { 
    useTheme,
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    tableCellClasses,
    styled,
    darken,
} from '@mui/material';
import { 
    WebsiteFavicon, 
    Pagination,
} from '../../../../general';

const ConversionMarker = {
    ACTIVE: 'ACTIVE',
    FORGOTTEN: 'FORGOTTEN',
    DELETED: 'DELETED',
    INACTIVE: 'INACTIVE',
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: darken(theme.palette.background.default, theme.palette.mode === 'dark' ? 0.125 : 0.06),
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
}));

const DomainsTable = ({ rows, totalPages, offset, handleOffsetChange, excludedMarkers = [] }) => {
    const theme = useTheme();
    const total = row => Object.values(ConversionMarker)
        .filter(marker => !excludedMarkers.includes(marker))
        .reduce((sum, marker) => sum + (row[marker] || 0), 0);
    return (
        <Box>
            {   
                !_.isEmpty(rows) ?
                <>
                    <TableContainer component={Paper}>
                        <Table 
                            sx={{ minWidth: 650 }} 
                            aria-label="simple table"
                        >
                            <TableHead sx={{
                                backgroundColor: darken(
                                    theme.palette.background.default, theme.palette.mode === 'dark' ? 0.125 : 0.06
                                )
                            }}>
                                <StyledTableRow>
                                    <StyledTableCell align="center">Position</StyledTableCell>
                                    <StyledTableCell>Domain</StyledTableCell>
                                    {
                                        !excludedMarkers.includes(ConversionMarker.ACTIVE) &&
                                        <StyledTableCell align="center">Active</StyledTableCell>
                                    }
                                    {
                                        !excludedMarkers.includes(ConversionMarker.INACTIVE) &&
                                        <StyledTableCell align="center">Inactive</StyledTableCell>
                                    }
                                    {
                                        !excludedMarkers.includes(ConversionMarker.FORGOTTEN) &&
                                        <StyledTableCell align="center">Forgotten</StyledTableCell>
                                    }
                                    {
                                        !excludedMarkers.includes(ConversionMarker.DELETED) &&
                                        <StyledTableCell align="center">Deleted</StyledTableCell>
                                    }
                                    <StyledTableCell align="center">Total</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                            {rows.map(row => (
                                <StyledTableRow
                                    key={row.id}
                                    sx={{
                                        ...(
                                            offset === 0 && rows.length > 10 && 
                                            {
                                                '&:nth-child(-n+3) td, &:nth-child(-n+3) th': {
                                                    backgroundColor: theme.palette.mode === 'dark' ? '#639A67' : '#A6CF98'
                                                },
                                                '&:nth-child(n+4):nth-child(-n+10) td, &:nth-child(n+4):nth-child(-n+10) th': {
                                                    backgroundColor: theme.palette.mode === 'dark' ? '#E7B10A' : '#FFD23F',
                                                },
                                                '&:nth-child(10) td, &:nth-child(10) th': {
                                                    borderBottom: '2px solid red',
                                                },
                                                '&:last-child td, &:last-child th': { 
                                                    border: 0 
                                                }
                                            }
                                        )
                                    }}
                                >
                                    <StyledTableCell align="center" component="th" scope="row">
                                        {row.id}
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row">
                                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                            <WebsiteFavicon url={row.domain} />
                                            {row.domain}
                                        </Box>
                                    </StyledTableCell>
                                    {
                                        !excludedMarkers.includes(ConversionMarker.ACTIVE) &&
                                        <StyledTableCell align="center">
                                            {row[ConversionMarker.ACTIVE]}
                                        </StyledTableCell>
                                    }
                                    {
                                        !excludedMarkers.includes(ConversionMarker.INACTIVE) &&
                                        <StyledTableCell align="center">
                                            {row[ConversionMarker.INACTIVE]}
                                        </StyledTableCell>
                                    }
                                    {
                                        !excludedMarkers.includes(ConversionMarker.FORGOTTEN) &&
                                        <StyledTableCell align="center">
                                            {row[ConversionMarker.FORGOTTEN]}
                                        </StyledTableCell>
                                    }
                                    {
                                        !excludedMarkers.includes(ConversionMarker.DELETED) &&
                                        <StyledTableCell align="center">
                                            {row[ConversionMarker.DELETED]}
                                        </StyledTableCell>
                                    }
                                    <StyledTableCell align="center">
                                        {total(row)}
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {   
                        totalPages > 1 && 
                        <Box sx={{width: '100%', mt: 3, display: 'flex', justifyContent: 'center'}}>
                            <Pagination
                                offset={offset} 
                                totalPages={totalPages} 
                                handleOffsetChange={handleOffsetChange}
                            />
                        </Box>
                    }
                </> :
                <Box sx={{height: '50vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <Typography variant="h6" component="div">
                        No data
                    </Typography>
                </Box>
            }
        </Box>
    );
}

export default DomainsTable;

export {
    ConversionMarker,
}